
/*
 * - scrollspy: see https://www.grafikart.fr/tutoriels/javascript/intersection-observer-804
 *      or see https://camwiegert.github.io/in-view/
 */

(function ($) {

	var isMobile      = false,
	authorizeBgNav    = true,

	$body             = $("body"),
	$overlay          = $(".overlay"),
	$hamburgerBtn     = $(".btn--hamburger"),
	$menuCloseBtn     = $(".top-menu__close .btn--close"),

	postHeader        = $('.wrapper--post-header'),
	preHeader         = $('.wrapper--pre-header'),
	menuSvgIcon       = $('.menu-icon svg'),
	menuSvgCart       = $('.cart svg'),
	menu              = $("section.menu"),
	navbar            = postHeader.find('.menu-icon');

	// Check the scroll offset and set the right bgcolor to the navbar and the svg icons

	$(window).on('scroll',function() {
	    var y = $(window).scrollTop();

	    if(y > 50){
  			$body.addClass('menu--bg');
	    } else {
	    	$body.removeClass('menu--bg');
	    }
	});

	// HAMBURGER BUTTON

	$hamburgerBtn.on("click", function() {
		$body.toggleClass("overlay--active");
	});

	// CLOSE MENU BUTTON

	$menuCloseBtn.on("click", function() {
		$body.removeClass("overlay--active");
	});

	// Check inputs forms from contact page
	$('.contact__form, .form').each(function() {
		$('body').on('blur', '.contact__form *[data-oblig=1], .form *[data-oblig=1]', function() {
			checkInput($(this));
		});

		if (typeof $(this).attr('data-check') != 'undefined') {
			$(this).find('*[data-oblig=1]').each(function() {
				checkInput($(this));
			});
		}
	});

	// Check inputs when submit
	$('body').on('click', '.contact__form button:submit, .form button:submit', function() {
		var go = true;

		$(this).closest('.contact__form, .form').find('*[data-oblig=1]').each(function() {

			var testInput = checkInput($(this));

			if (testInput === false) {
				go = false;
			}
		});

		if (go === false) {
			return false;
		}
	});
			
	// Demande de doc
	$('.wrapper--demande-doc .see-more').on('click', function(e){
		$('.franchise-line').find('.hidden').removeClass('hidden')
		$(this).remove();
	});
	
	// Liens sur les cartouches réseaux
	
	$(document).on('click', '.wrapper--franchise-item .franchise-item .franchise-item__img, .wrapper--franchise-item .franchise-item .franchise-item__content, .wrapper--franchise-item .franchise-item .franchise-item__stats, .wrapper--franchise-item .franchise-item .franchise-item__cta .btn-cta--franchise', function(e){
		$franchiseItemBloc = $(this);
		
		var href = $franchiseItemBloc.parents('.franchise-item').find('.franchise-item__content .title').attr('href');
		
		if (typeof href != 'undefined') {
			window.location.href = href;
		}
	});

	// Add a class to td that contain images
	$('.franchise__content tr img, .franchise__content td img').parents('tr, td').addClass('has-image');

	// Fix touch event on iphone
	$('.overlay--active a').on('click touchend', function(e) {
		var el = $(this);
		var link = el.attr('href');
		if (link) {
			window.location = link;
		}
	});

	// Show more sectors on the homepage	
	$('.wrapper--top-cities').on('click', 'button[id^=show-rubriques-]', function() {
		var breakpoint = $(this).attr('data-breakpoint');
		var nbRubriques = $(this).attr('data-nb-rubriques');
		
		$('.top-cities .hidden-rubrique-' + breakpoint + ':lt(' + nbRubriques + ')').removeClass('hidden-rubrique-' + breakpoint);
		
		// Suppression du bouton
		if ($('.top-cities .hidden-rubrique-' + breakpoint).length == 0) {
			$(this).remove();
		}
	});
	
	// Show more franchisors on the homepage	
	$('.wrapper--franchises-gallery').on('click', 'button[id^=show-reseaux-]', function() {
		var breakpoint = $(this).attr('data-breakpoint');
		var nbReseaux = $(this).attr('data-nb-reseaux');
		
		$('.franchises-gallery .hidden-reseau-' + breakpoint + ':lt(' + nbReseaux + ')').removeClass('hidden-reseau-' + breakpoint);
		
		// Suppression du bouton
		if ($('.franchises-gallery .hidden-reseau-' + breakpoint).length == 0) {
			$(this).remove();
		}
	});

	// Scroll Top
	$(window).scroll(function(){	
        if ($(this).scrollTop() > 200) {
            $('.arrow-up').removeClass('hidden').fadeIn();
        } else {
            $('.arrow-up').addClass('hidden').fadeOut();
        }
	});

    $('.arrow-up').on('click', function(){
        $('html, body').animate({ scrollTop: 0 }, 500);
        return false;
    });

	// Le champ select Objet et les options
	$('input[name=typeContact]:radio').change(function () {
		$('#champObjet').find('option').not(':first').remove();

		if($(this).val() == 'Franchiseur') {
			$('#champObjet').append($("#selectFranchiseur > option").clone());
		} else if ($(this).val() == 'Candidat a la franchise') {
			$('#champObjet').append($("#selectCandidat > option").clone());
		} else if ($(this).val() == 'Autre') {
			$('#champObjet').append($("#selectAutre > option").clone());
		}
	});

	// Cherche toute les vidéos Youtube
	var $container = $('.site-content'),
		$videos = $('.site-content iframe[src*=\'youtube.com\']');

	if ($videos.length > 0) {
		// Pour chaque vidéo sur la page
		$videos.each(function() {
			// On ajoute un attribut pour garder le ratio de la video
			// ajout des propriétés max-width et max-height avec les dimensions actuelles de la video
			// Suppression des attributs height et width
			$(this).attr('data-aspectRatio', this.height / this.width)
					.css({'max-width':$(this).width(), 'max-height':$(this).height()})
					.removeAttr('height')
					.removeAttr('width');
		});

		// Fonction pour resize la video
		var resizeVideo = function () {
			var $videoWidth = $container.width() - 50; // largeur de la video

			$videos.each(function() {
				var $el = $(this);
				$el.width($videoWidth)
					.height($videoWidth * $el.attr('data-aspectRatio'));
			});
		}

		window.addEventListener('resize', resizeVideo);
		resizeVideo(); // Lancement du resize lors du chargement de la page	
	}
}(jQuery))


// WEBPACK FOOTER //
// ./resources/assets/js/lib/main.js